module.exports = __webpack_public_path__ + "static/off-page-seo-591afa27bd844f4d276fa2525ab0282f.png";